var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-user-cog-icon lucide-user-cog",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H6a4 4 0 0 0-4 4v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.305 16.53.923-.382"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.228 13.852-.923-.383"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 12.228-.383-.923"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 17.772-.383.924"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.148 12.228.383-.923"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m19.53 18.696-.382-.924"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.772 13.852.924-.383"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.772 16.148.924.383"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCog);
export default __webpack_public_path__ + "static/media/user-cog.3ec151586cc5f3c7c3098629f68466f6.svg";
export { ForwardRef as ReactComponent };